import CryptoJS from "crypto-js";
import * as qiniu from "qiniu-js";
import store from "../../store/index";
import router from "../../router";

function isElectron() {
  return navigator.userAgent.indexOf("Electron/") >= 0 &&
    navigator.userAgent.indexOf("WebKit") >= 0
    ? true
    : false;
}
function rgbToHex(rgb) {
  let arr = rgb.replace("rgb", "").replace("(", "").replace(")", "").split(",");
  // 转十六进制
  let h = parseInt(arr[0]).toString(16);
  let e = parseInt(arr[1]).toString(16);
  let x = parseInt(arr[2]).toString(16);
  return "#" + h + e + x;
}
function getRealKey(key) {
  let newKey = "";
  let spliceIdxArr = [3, 8, 10, 17];
  let letterArr = key.split("");
  for (let i = 0; i < letterArr.length; i++) {
    let letter = letterArr[i];
    let hasFlag = spliceIdxArr.find((val) => {
      return val == i;
    });
    if (!hasFlag) {
      newKey += letter;
    }
  }
  return newKey;
}

function encrypt(data, constKey = "1234567890123456") {
  //加密
  let key = CryptoJS.enc.Utf8.parse(constKey);
  let srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  const cipher = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: "",
  });
  const base64Cipher = cipher.ciphertext.toString(CryptoJS.enc.Base64);
  return base64Cipher;
}
function decrypt(encrypted, constKey = "1234567890123456") {
  //解密
  let key = CryptoJS.enc.Utf8.parse(constKey);
  const restoreBase64 = encrypted.replace(/\-/g, "+").replace(/\_/g, "/");
  const decipher = CryptoJS.AES.decrypt(restoreBase64, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
    iv: "",
  });
  let resultDecipher = CryptoJS.enc.Utf8.stringify(decipher);
  return resultDecipher;
}

function getUrlKey(name) {
  //获取url参数
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        window.location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

function getBaseURL(file) {
  var url = null;
  if (window.createObjectURL != undefined) {
    // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) {
    // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) {
    // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

function changeFileName(filename) {
  return filename.replace(/.[a-zA-Z0-9]+$/, (match) => {
    return `-${Date.now()}${match}`;
  });
}

async function uploadQiniu(file, key, token, option, unupload = false) {
  return new Promise(async (resolve, reject) => {
    const config = {
      useCdnDomain: true, //是否使用 cdn 加速域名
      region: null, //选择上传域名区域；当为 null 或 undefined 时，自动分析上传域名区域
    };
    //console.log("filev file file:",file);

    const putExtra = {
      fname: changeFileName(file.name),
    };
    var observable = await qiniu.upload(file, key, token, putExtra, config);

    const observer = {
      next: option.onProgress,
      error(err) {
        reject(err);
      },
      complete(res) {
        resolve(res);
      },
    };
    var subscription = await observable.subscribe(observer);

    if (unupload) {
      subscription.unsubscribe(); // 上传取消
    }
  });
}

//时间戳转日历
/**
 * @desc 格式化日期字符串
 * @param { Nubmer} - Date日期 , 时间不能大于当前时间，大于当前时间会返回“刚刚”。
 * @returns { String } 格式化后的日期字符串
 // 2012年01月10日 12:46
 //刚刚
 //16分钟前
 //今天10:10
 //昨天10:10
 //02月10日 10:10:11
 //2012年10月10日 10:10:11
 */
function dateFormat(date) {
  if (!date) return "";
  //new Date 在 ios safari浏览器有兼容性问题处理如下：ios不支持2027-2-22 16:23，需要改为2027/2/22 16:23
  // ? 兼容 ios safari : 兼容其他浏览器
  let $this =
    new Date(date) == "Invalid Date"
      ? new Date(date.replace(/-/g, "/"))
      : new Date(date);
  var timestamp = parseInt(Date.parse($this)) / 1000; //- 8 * 60 * 60; //（本地时间）东八区减去8小时;

  function zeroize(num) {
    return (String(num).length == 1 ? "0" : "") + num;
  }
  var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数
  var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  var tmDate = new Date(timestamp * 1000); // 参数时间戳转换成的日期对象

  var Y = tmDate.getFullYear(),
    m = tmDate.getMonth() + 1,
    d = tmDate.getDate();
  var H = tmDate.getHours(),
    i = tmDate.getMinutes(),
    s = tmDate.getSeconds();

  if (timestampDiff < 60) {
    // 一分钟以内
    return "刚刚";
  } else if (timestampDiff < 3600) {
    // 一小时前之内
    return Math.floor(timestampDiff / 60) + "分钟前";
  } else if (
    curDate.getFullYear() == Y &&
    curDate.getMonth() + 1 == m &&
    curDate.getDate() == d
  ) {
    return "今天 " + zeroize(H) + ":" + zeroize(i) + ":" + zeroize(s);
  } else {
    var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
    if (
      newDate.getFullYear() == Y &&
      newDate.getMonth() + 1 == m &&
      newDate.getDate() == d
    ) {
      return "昨天 " + zeroize(H) + ":" + zeroize(i) + ":" + zeroize(s);
    } else if (curDate.getFullYear() == Y) {
      // return  zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i) + ':' + zeroize(s);
      return zeroize(m) + "月" + zeroize(d) + "日";
    } else {
      // return  Y + '年' + zeroize(m) + '月' + zeroize(d) + '日 ' + zeroize(H) + ':' + zeroize(i) + ':' + zeroize(s);
      return Y + "年" + zeroize(m) + "月" + zeroize(d) + "日";
    }
  }
}

//时间戳转小时、分、秒
function ts2timeHour(ts, isSpecial) {
  console.log("ts2timeHour...");
  ts = ts * 0.001;
  let h = parseInt(ts / 3600);
  let m = parseInt(((ts % (3600 * 24)) % 3600) / 60);
  let s = parseInt((((ts % (3600 * 24)) % 3600) % 60) % 60);
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }

  let result = "";

  if (h > 0) {
    result += h + "小时";
  }
  if (m > 0) {
    result += m + "分";
  }
  if (s > 0) {
    result += s + "秒";
  }
  return result;
}

function format(date, format = "yyyy-MM-dd hh:mm:ss") {
  if (!date) return "";
  //new Date 在 ios safari浏览器有兼容性问题处理如下：
  // ? 兼容safari : 兼容其他浏览器
  let $this =
    new Date(date) == "Invalid Date"
      ? new Date(date.substr(0, 19))
      : new Date(date);

  let o = {
    "M+": $this.getMonth() + 1,
    "d+": $this.getDate(),
    "h+": $this.getHours(),
    "m+": $this.getMinutes(),
    "s+": $this.getSeconds(),
    "q+": Math.floor(($this.getMonth() + 3) / 3),
    S: $this.getMilliseconds(),
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      ($this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
}

async function connectMqtt(respData) {
  return new Promise(async (resolve, reject) => {
    let client = new Paho.MQTT.Client(
      respData.object.host,
      respData.object.port,
      respData.object.clientId
    );

    client.onConnectionLost = onConnectionLost;
    client.onMessageArrived = onMessageArrived;

    client.connect({
      userName: respData.object.accessKey,
      password: decodeURIComponent(respData.object.password),
      keepAliveInterval: 100,
      cleanSession: false,
      useSSL: true,
      onSuccess: onConnect,
      onFailure: function (responseObject) {
        console.log("connet onFailure ==", responseObject);
      },
    });

    function onConnect() {
      // 建立连接后，进行订阅并发送消息。
      client.subscribe(respData.object.topic, {
        onSuccess: function (responseObject) {
          console.log("success");
        },
        onFailure: function (responseObject) {
          console.log("conneted onFailure ==", responseObject);
        },
      });
    }

    //当客户端失去连接时调用
    function onConnectionLost(responseObject) {
      if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:", responseObject);
      }
    }

    // 消息到达时调用
    let _this = this;
    async function onMessageArrived(message) {
      client.unsubscribe(respData.object.topic, {
        onSuccess: function (responseObject) {
          client.disconnect();
        },
        onFailure: function (responseObject) {},
      });
      resolve(JSON.parse(message.payloadString));
      /* console.log(message)
      let response = JSON.parse(message.payloadString);
      await store.commit("updateState",response)
      await sessionStorage.setItem("store",JSON.stringify(store.state))
      router.push({name:'home'})*/
    }
  });
}

function getFileName(name) {
  //1图片，2视频，3MP3，4word，5压缩文件，6excel，7记事本，8ppt，9pdf，10其他
  let json = { type: 10, suffix: name.substring(name.lastIndexOf(".") + 1) };
  if (name.match(/\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.webp/g)) {
    json = { type: 1, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.mp4|\.mpeg|\.avi|\.mov|\.3gp|\.wmv/g)) {
    json = { type: 2, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.mp3|\.wma/g)) {
    json = { type: 3, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.doc|\.docx/g)) {
    json = { type: 4, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.rar|\.zip/g)) {
    json = { type: 5, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.xls|\.xlsx/g)) {
    json = { type: 6, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.txt/g)) {
    json = { type: 7, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.ppt|\.pptx|\.pps|\.pot|\.ppa/g)) {
    json = { type: 8, suffix: name.substring(name.lastIndexOf(".") + 1) };
  } else if (name.match(/\.pdf/g)) {
    json = { type: 9, suffix: name.substring(name.lastIndexOf(".") + 1) };
  }
  return json;
}

export function getVideoPoster(url) {
  if (url.includes("tencos")) {
    return url + "?ci-process=snapshot&time=1&format=png";
  } else {
    return url + "?vframe/jpg/offset/0";
  }
}

//时间戳转天、小时、分、秒
export function ts2timeDay(ts, isSpecial) {
  ts = ts * 0.001;
  let d = parseInt(ts / (3600 * 24));
  let h = parseInt((ts % (3600 * 24)) / 3600);
  let m = parseInt(((ts % (3600 * 24)) % 3600) / 60);
  let s = parseInt((((ts % (3600 * 24)) % 3600) % 60) % 60);
  if (h < 10) {
    h = "0" + h;
  }
  if (m < 10) {
    m = "0" + m;
  }
  if (s < 10) {
    s = "0" + s;
  }
  if (d > 0) {
    if (isSpecial) {
      return d + "天 " + h + "小时" + m + "分";
    } else {
      return d + "天 " + h + ":" + m + ":" + s;
    }
  } else {
    if (h > 0) {
      if (isSpecial) {
        return h + "小时" + m + "分" + s + "秒";
      } else {
        return h + ":" + m + ":" + s;
      }
    } else {
      if (isSpecial) {
        return m + "分" + s + "秒";
      } else {
        return m + ":" + s;
      }
    }
  }
}

export default {
  getRealKey,
  encrypt,
  decrypt,
  getUrlKey,
  uploadQiniu,
  getBaseURL,
  connectMqtt,
  dateFormat,
  format,
  getFileName,
  ts2timeHour,
  ts2timeDay,
  isElectron,
  getVideoPoster,
  rgbToHex,
};
